import React, { useState, useEffect } from "react";
import GradientButton from "../../Buttons/GradientButton/GradientButton";
import NftInteractionModal from "../NftInteractionModal/NftInteractionModal";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledCtaText from "../../../common/components/styledCtaText/StyledCtaText";
import InsufficientFundsModal from "../InsufficientFundsModal/InsufficientFundsModal";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
import {
  getGasPrice,
  getWalletBalance,
} from "../../../context/MintingContract";
import { useSelector } from "react-redux";
import { setUserBalance } from "../../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import useBuyNFT from "../../../Hooks/api/useBuyNfs";
import Spinner from "../../Loader/spinner";

const CheckoutModal = ({ closeModal, nft }) => {
  const dispatch = useDispatch();
  const [showInsufficientFunds, setInsufficientFundsModal] = useState(false);
  const { walletAddress, walletBalance } = useSelector((state) => state.user);
 
  const { buySingleItem, loading } = useBuyNFT();
  useEffect(() => {
    const fetchBalance = async () => {
      if (walletAddress) {
        try {
          const { ethBalance } = await getWalletBalance(walletAddress);
        
          dispatch(setUserBalance(ethBalance));
        } catch (error) {
          console.error("Error fetching balance:", error);
        }
      }
    };

    fetchBalance();
  }, [walletAddress, dispatch]);

  const handleButtonClick = async () => {
    const gasPrice = await getGasPrice();
    
    if (walletBalance > nft.price) {
      await buySingleItem(
        nft?.nft_id, 
        nft.price,  
        gasPrice,  
        () => closeModal() 
      );
    } else {
      setInsufficientFundsModal(true);
    }
  };
  
  

  // const handleButtonClick = async () => {
  //   if (walletBalance > nft.price) {
  //     await buySingleItem(
  //       nft?.nft_id, 
  //       nft.price, 
  //       () => {
  //         closeModal();
  //       }, 
  //       (error) => {
  //         console.error("Transaction failed:", error);
  //       }
  //     );
  //   } else {
  //     setInsufficientFundsModal(true);
  //   }
  // };
  return (
    <NftInteractionModal
      handleClose={closeModal}
      width={"w-[95%] sm:w-4/5 md:w-4/6 lg:w-1/2 xl:w-[40%]"}
      content={
        <div className="flex flex-col gap-3 py-10 px-5 sm:px-10 xl:px-20">
          <div className="flex flex-col justify-center items-center text-center mb-4">
            <StyledH4Heading fontColor={"textGradient"}>
              It’s Time To Purchase
            </StyledH4Heading>
            <StyledMdText>
              Heads up, Check the details below and buy your NFTs before someone
              else.
            </StyledMdText>
          </div>

          <div className="bg-[#252525] border border-bright-yellow p-4 rounded-xl">
            <div className="flex justify-between">
              <div className="flex items-center justify-center gap-5">
                <img
                  src={nft?.image}
                  alt={nft?.name}
                  className="w-12 rounded-[4px]"
                />
                <StyledCtaText>{nft?.name}</StyledCtaText>
              </div>
              <div className="flex gap-2 items-center justify-end">
                <img
                  src="/assets/nft-price-icon.svg"
                  alt="Price Icon"
                  width={10}
                />
                <StyledCtaText>{nft?.price} ETH</StyledCtaText>
              </div>
            </div>
          </div>
          <div className="bg-[#252525] border border-bright-yellow p-4 flex flex-col gap-2 rounded-xl">
            <div className="flex justify-between">
              <StyledCtaText>Total</StyledCtaText>
              <StyledH6Heading>{nft?.price} ETH</StyledH6Heading>
            </div>
            <hr className="h-[0.5px] w-full bg-white opacity-40" />
            <div className="flex justify-between">
              <StyledCtaText>Grand Total</StyledCtaText>
              <StyledH6Heading>{nft?.price} ETH</StyledH6Heading>
            </div>
          </div>

          <div className={`w-full mt-2 ${loading && 'animate-pulse'}`}>
            <GradientButton
              onClick={handleButtonClick}
              fontColor={"w-full"}
              children={loading ? <Spinner /> : "Pay Now"}
              disabled={loading}
            />
          </div>
          {showInsufficientFunds && (
            <InsufficientFundsModal
              nft={nft}
              closeModal={() => setInsufficientFundsModal(false)}
            />
          )}
        </div>
      }
    />
  );
};

export default CheckoutModal;
